import React from "react";

/**
 * SelectDropdown Component
 *
 * Reusable select dropdown with label and consistent styling.
 *
 * @param {string} label - Label text to display above the select
 * @param {string} value - Current selected value
 * @param {function} onChange - Handler for value changes
 * @param {array} options - Array of {value, label} objects
 * @param {string} placeholder - Placeholder option text (default: "Select...")
 * @param {string} helperText - Optional helper text below label
 */
const SelectDropdown = ({
  label,
  value,
  onChange,
  options = [],
  placeholder = "Select...",
  helperText,
}) => {
  return (
    <div>
      {label && (
        <label
          style={{
            display: "block",
            fontSize: "14px",
            fontWeight: "500",
            color: "#525252",
            marginBottom: "8px",
          }}
        >
          {label}
        </label>
      )}
      {helperText && (
        <p
          style={{
            fontSize: "13px",
            color: "#737373",
            margin: "0 0 8px 0",
          }}
        >
          {helperText}
        </p>
      )}
      <select
        value={value}
        onChange={onChange}
        style={{
          width: "100%",
          padding: "12px 16px",
          fontSize: "15px",
          color: value ? "#1a1a1a" : "#a3a3a3",
          backgroundColor: "#fff",
          border: "1px solid #e5e5e5",
          borderRadius: "8px",
          outline: "none",
          cursor: "pointer",
          transition: "border-color 0.2s ease",
          boxSizing: "border-box",
        }}
        onFocus={(e) => (e.currentTarget.style.borderColor = "#a3a3a3")}
        onBlur={(e) => (e.currentTarget.style.borderColor = "#e5e5e5")}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectDropdown;
